<div class="content">
  <app-navigation></app-navigation>
  <div class="page">
    <app-page-header></app-page-header>
    <router-outlet></router-outlet>
  </div>
</div>

